import { getCookieByKey, setCookie } from 'utils';

const SALESFORCE_ID = 'sfmc_key';
const NEWSLETTER_ID = 'bhnlp';

const COOKIE_EXPIRE = { days: 365 };

export enum NewsletterModalCookie {
  DECLINED = 'declined',
  ACCEPTED = 'accepted',
  LATER = 'later'
}

export const setNewsletterCookie = (value: NewsletterModalCookie) => {
  setCookie(NEWSLETTER_ID, value, COOKIE_EXPIRE);
};

export const hasCorrectCookies = (): boolean => {
  if (getCookieByKey(SALESFORCE_ID)) {
    return false;
  }

  const newsletterCookie = getCookieByKey(NEWSLETTER_ID);

  if (
    newsletterCookie === NewsletterModalCookie.DECLINED ||
    newsletterCookie === NewsletterModalCookie.ACCEPTED
  ) {
    return false;
  }

  return true;
};

export const hasSelectedShowLater = (): boolean => {
  const newsletterCookie = getCookieByKey(NEWSLETTER_ID);

  return newsletterCookie === NewsletterModalCookie.LATER;
};
